import styled from 'styled-components';

export const FaqWrapper = styled.div`
  padding: 3rem 0;
  max-width: 1200px;
  margin: auto;
  margin-top: 90px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: 'Figtree', sans-serif;
  /* align-items: center; */

  @media (max-width: 800px) {
    padding: 2rem 1rem;
    margin-top: 70px;
  }
`

export const FaqTitle = styled.h2`
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
  text-align: center;
  font-family: 'FigtreeBold', sans-serif;
`

export const FaqSectionTitle = styled.h3`
  font-size: 1.3rem;
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
  font-family: 'FigtreeBold', sans-serif;
`

export const FaqQuestion = styled.p`
  font-size: 1rem;
  margin: 0.25rem 0;
  font-family: 'FigtreeBold', sans-serif;
`
export const FaqAnswer = styled.p`
  font-size: 0.8rem;
  margin: 0.5rem 0 1.5rem 0;
  line-height: 1.5;
  font-family: 'Figtree', sans-serif;
`